import type { ScriptExecution } from "playground/agent-tools/contract";
import { wrapScriptWithArgs } from "playground/builder/script-invocation";

export interface AgentEvalInput {
  code?: string;
  filePath?: string;
  args?: Record<string, unknown>;
  /** Where the script runs; the host routes on it before this code sees it. */
  runtime?: "worker" | "page";
  /** The chat a page-run eval acts for, added by the client that runs it. */
  execution?: ScriptExecution;
}

export type ResolvedConsoleInput =
  | { ok: true; code: string; display: string }
  | { ok: false; display: string; error: string };

export async function resolveConsoleInput(
  msg: AgentEvalInput,
  read: (path: string) => Promise<string | undefined>,
): Promise<ResolvedConsoleInput> {
  if (msg.code && msg.filePath)
    return {
      ok: false,
      display: "eval(?)",
      error: "Provide either code or filePath, not both",
    };
  if (typeof msg.code === "string" && msg.code.length > 0)
    return { ok: true, code: msg.code, display: msg.code };
  if (typeof msg.filePath === "string" && msg.filePath.length > 0) {
    const display = `eval(${JSON.stringify(msg.filePath)}, ${JSON.stringify(msg.args ?? {})})`;
    const source = await read(msg.filePath);
    return source?.trim()
      ? { ok: true, code: wrapScriptWithArgs(source, msg.args ?? {}), display }
      : {
          ok: false,
          display,
          error: `Script not found or empty: ${msg.filePath}`,
        };
  }
  return {
    ok: false,
    display: "eval(?)",
    error: "eval: neither code nor filePath provided",
  };
}
